var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "url(#paint0_linear_6057_37939)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7627 43.2071L31.3648 55.6893L51.7904 27.3203L26.7627 43.2071Z",
    fill: "#C2DAEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8721 45.9805L31.4307 55.8152L42.2111 46.6737L31.8721 45.9805Z",
    fill: "#9FCDE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7834 22.5283L16.5257 37.8253C15.3884 38.2572 15.4185 39.8766 16.5711 40.2663L26.9529 43.7744L50.5935 28.5186L31.8703 45.9809L46.446 57.0423C47.9624 58.1928 50.1611 57.4193 50.6226 55.5728L58.5021 24.0558C58.7561 23.0389 57.7629 22.156 56.7834 22.5283Z",
    fill: "#ECF8FD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6057_37939",
    x1: 11.7159,
    y1: 11.7155,
    x2: 68.2845,
    y2: 68.2841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094D4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactTelegram);
export default __webpack_public_path__ + "static/media/contactTelegram.b8d4ad3916e7c93ea99a60768af45a13.svg";
export { ForwardRef as ReactComponent };